import jwtDecode from 'jwt-decode';

const getters = {
  isLoggedIn: (state) => !!state.refreshToken,
  hasSipAccount: (state) => (!!state.sip.username && !!state.sip.password),
  permissions: (state) => {
    if (!state.token) return [];
    const payload = jwtDecode(state.token);
    return payload.permissions || [];
  },
  superuser: (state) => {
    if (!state.token) return [];
    const payload = jwtDecode(state.token);
    return payload.superuser || false;
  }
};

export default getters;
